module.exports = __webpack_public_path__ + "static/media/Amealio_Illustrations-01.271fa138.svg";